import { render, staticRenderFns } from "./TransaksiReceiptView.vue?vue&type=template&id=31cac142"
import script from "./TransaksiReceiptView.vue?vue&type=script&lang=js"
export * from "./TransaksiReceiptView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports